import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FaqPageBaseComponent } from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { LoaderWebComponent } from '@resident-nx/web/ui';
import {
  NgbAccordionDirective,
  NgbAccordionItem,
  NgbAccordionHeader,
  NgbAccordionToggle,
  NgbAccordionButton,
  NgbCollapse,
  NgbAccordionCollapse,
  NgbAccordionBody,
} from '@ng-bootstrap/ng-bootstrap';
import { IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IconWebComponent,
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionToggle,
    NgbAccordionButton,
    NgbCollapse,
    NgbAccordionCollapse,
    NgbAccordionBody,
    LoaderWebComponent,
    AsyncPipe,
    TranslateModule,
  ],
})
export class FaqWebComponent extends FaqPageBaseComponent {}
